import { checkPermission } from '@/router/guards.ts'

const TransactionReportsModule = () => import('./TransactionReportsModule.vue')
const TransactionsReportIndex = () => import('./views/TransactionsReportIndex.vue')

export const transactionReportsRoute = {
  path: '/report',
  component: TransactionReportsModule,
  meta: {
    title: 'Transactions',
    requiresAuth: true,
    keepAlive: true,
  },
  children: [
    {
      path: 'transactions',
      name: 'transactions-report-index',
      component: TransactionsReportIndex,
      meta: {
        permission: 'report.transactions',
      },
      beforeEnter: checkPermission('report.transactions'),
    },
  ],
}
